import React from 'react';
import {
    Switch, Route, Redirect,
} from 'react-router-dom';
import Painel from '../Painel';
import ProjetosEspeciais from '../ProjetosEspeciais';
import NovaCampanha from '../NovasCampanhas';
import MidiaCampanhas from '../MidiaCampanhas';
import utils from '../../../services/utils';

const HomeCampanhas = () => (
	<>
		<Switch>
			<Route path={`${utils.basePath()}/campanhas`} component={Painel} exact />
			<Route path={`${utils.basePath()}/campanhas/campanha`} component={() => <h1>Campanhas</h1>} />
			<Route path={`${utils.basePath()}/campanhas/relatorios`} component={() => (<h1>Relatórios</h1>)} />
			<Route path={`${utils.basePath()}/campanhas/projetos-especiais`} component={ProjetosEspeciais} exact />
			<Route path={`${utils.basePath()}/campanhas/nova-campanha`} component={NovaCampanha} />
			<Route path={`${utils.basePath()}/campanhas/sites`} component={() => (<h1>Sites</h1>)} />
			<Route path={`${utils.basePath()}/campanhas/midia`} component={MidiaCampanhas} exact />
			<Redirect key="pageNotFound" from="*" to="/404" />,
		</Switch>
	</>
);

export default HomeCampanhas;
